import React from 'react'

// product Images
import IMG34 from "../images/product-list/34.jpg"
import IMG1 from "../images/product-list/1.jpg"
import IMG4 from "../images/product-list/4.jpg"
import IMG17 from "../images/product-list/17.jpg"
import IMG3 from "../images/product-list/3.jpg"
import IMG001 from "../images/product-list/001.jpg"
import IMG10 from "../images/product-list/10.jpg"
import IMG04 from "../images/product-list/04.jpg"


export const data = [{
    image: IMG34,
    title: "Slim Fit Cotton Shirt",
    price: "$500.00",
    discount_price:"$600.00",
    tag:"old",
    discount :"not on sale"
},{
    image: IMG1,
    title: "Slim Fit Cotton Shirt",
    price: "$400.00",
    discount_price:"$600.00",
    tag:"old",
    discount :"not on sale"
},
{
    image: IMG4,
    title: "Slim Fit Cotton Shirt",
    price: "$400.00",
    discount_price:"$600.00",
    tag:"new",
    discount :"on sale"
},
{
    image: IMG17,
    title: "Slim Fit Cotton Shirt",
    price: "$400.00",
    discount_price:"$600.00",
    tag:"old",
    discount :"not on sale"
},
{
    image: IMG3,
    title: "Slim Fit Cotton Shirt",
    price: "$400.00",
    discount_price:"$600.00",
    tag:"old",
    discount :"not on sale"
},
{
    image: IMG001,
    title: "Slim Fit Cotton Shirt",
    price: "$400.00",
    discount_price:"$600.00",
    tag:"old",
    discount :"not on sale"
},
{
    image: IMG10,
    title: "Slim Fit Cotton Shirt",
    price: "$400.00",
    discount_price:"$600.00",
    tag:"old",
    discount :"not on sale"
},
{
    image: IMG04,
    title: "Slim Fit Cotton Shirt",
    price: "$400.00",
    discount_price:"$600.00",
    tag:"old",
    discount :"not on sale"
},
]
export default data
